import { EditForm } from "./edit-form";

export const Websites = { EditForm };
